import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LangContext = createContext(null);

const initialLang = () => {
  const saved = localStorage.getItem("zenvio-lang");
  if (saved === "en" || saved === "da") return saved;
  return navigator.language?.toLowerCase().startsWith("da") ? "da" : "en";
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(initialLang);
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("zenvio-lang", l);
  };
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
